import createIconSetFromFontello from "@expo/vector-icons/createIconSetFromFontello";
import fontelloConfig from "./icon-font.json";

const Icon = createIconSetFromFontello(
	fontelloConfig,
	"memorangicons",
	"memorangicons.ttf",
);
export default Icon;
